import { NavigationMenu } from '@cms/components/navigation/NavigationMenu'
import { FIXED_ASSETS } from '@dl/declarations'
import PageContainer from '../../components/ui/PageContainer'

const OverviewPage = () => {
    return (
        <PageContainer className='px-0! h-full dark'>
            <img
                alt="Logo"
                src={FIXED_ASSETS.LLAMA_DESK}
                className="w-lg aspect-2.25/1 object-cover border-[0.5px] rounded-[15px] my-[50px]"
            />

            <h2>
                Create, customise and organise your articles
            </h2>

            <NavigationMenu />
        </PageContainer>
    )
}

export default OverviewPage